// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "电气工程导论",
      "tec": "钱小毅",
      "week": "6-13周",
      "add": "教学楼A座320电力"
    },
    [
      {
        "sub": "大学英语（一）",
        "tec": "顾骁南",
        "week": "6-17周",
        "add": "教学楼A座118电力"
      },
      {
        "sub": "26电气1-3",
        "tec": "高琳琳",
        "week": "6-17周",
        "add": "教学楼A座119信息"
      },
      {
        "sub": "26电气2-2",
        "tec": "刘莹",
        "week": "6-17周",
        "add": "实训楼E座401管理"
      },
      {
        "sub": "26电气2-3",
        "tec": "刘岩",
        "week": "6-17周",
        "add": "实训楼E座403语音室"
      },
      {
        "sub": "26电气2-1",
        "tec": "宋扬",
        "week": "6-17周",
        "add": "实训楼E座406语音室"
      },
      {
        "sub": "26电气1-2",
        "tec": "张然",
        "week": "6-17周",
        "add": "实训楼E座412语音室"
      },
      {
        "sub": "26电气1-4",
        "tec": "钟倩",
        "week": "6-17周",
        "add": "实训楼E座503语音室"
      },
      {
        "sub": "26电气2-4",
        "tec": "齐越",
        "week": "6-17周",
        "add": "实训楼E座310"
      }
    ],
    0,
    {
      "sub": "形势与政策",
      "tec": "王姝",
      "week": "6-9周",
      "add": "教学楼C座310教务"
    },
    {
      "sub": "军事理论",
      "tec": "黄明",
      "week": "6,8周",
      "add": "教学楼A座116电力"
    }
  ],
  "2": [
    {
      "sub": "高等数学（一）",
      "tec": "赵丹",
      "week": "6-17周",
      "add": "教学楼C座215教务"
    },
    {
      "sub": "体育（一）",
      "tec": "樊绍斌",
      "week": "7-18周",
      "add": "（7-18周[03-04节]）"
    },
    {
      "sub": "人工智能与计算思维",
      "tec": "张丕振",
      "week": "7,9,11,13,15周",
      "add": "教学楼A座218电力"
    },
    0,
    0
  ],
  "3": [
    0,
    {
      "sub": "高等数学（一）",
      "tec": "赵丹",
      "week": "6-17周",
      "add": "教学楼C座113教务"
    },
    0,
    0,
    [
      {
        "sub": "健康教育",
        "tec": "白鹏",
        "week": "6-9,11-17周",
        "add": "教学楼C座110教务"
      },
      {
        "sub": "健康教育",
        "tec": "白鹏",
        "week": "10周",
        "add": "教学楼C座110教务"
      },
      {
        "sub": "健康教育",
        "tec": "白鹏",
        "week": "10周",
        "add": "教学楼C座110教务"
      }
    ]
  ],
  "4": [
    0,
    {
      "sub": "军事理论",
      "tec": "黄明",
      "week": "6-12周",
      "add": "教学楼C座115教务"
    },
    [
      {
        "sub": "大学英语（一）",
        "tec": "张然",
        "week": "6-17周",
        "add": "教学楼A座117电力"
      },
      {
        "sub": "26电气1-4",
        "tec": "宋扬",
        "week": "6-17周",
        "add": "教学楼A座118电力"
      },
      {
        "sub": "26电气1-2",
        "tec": "刘岩",
        "week": "6-17周",
        "add": "教学楼A座119信息"
      },
      {
        "sub": "26电气2-1",
        "tec": "刘莹",
        "week": "6-17周",
        "add": "教学楼A座222电力"
      },
      {
        "sub": "26电气2-3",
        "tec": "齐越",
        "week": "6-17周",
        "add": "教学楼A座226电力"
      },
      {
        "sub": "26电气1-1",
        "tec": "钟倩",
        "week": "6-17周",
        "add": "教学楼D座215经管"
      },
      {
        "sub": "26电气2-4",
        "tec": "高琳琳",
        "week": "6-17周",
        "add": "实训楼E座403语音室"
      },
      {
        "sub": "26电气2-2",
        "tec": "顾骁南",
        "week": "6-17周",
        "add": "实训楼Ｅ座501语音室"
      }
    ],
    0,
    {
      "sub": "就业创业指导",
      "tec": "赵毅王刚王祎雪刘东岩",
      "week": "13-16周",
      "add": "大活礼堂"
    }
  ],
  "5": [
    [
      {
        "sub": "人工智能与计算思维",
        "tec": "张丕振",
        "week": "6,8,10,12,14,16周",
        "add": "实训楼C座318"
      },
      {
        "sub": "人工智能与计算思维",
        "tec": "张丕振",
        "week": "7,9,11,13,15周",
        "add": "教学楼A座217电力"
      }
    ],
    {
      "sub": "高等数学（一）",
      "tec": "赵丹",
      "week": "6-17周",
      "add": "教学楼C座115教务"
    },
    0,
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
